import { Box, Button, Card, styled, Typography } from "@mui/material";

export const PreviewRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "50%",
  position: "absolute",
  bottom: 50,
  padding: 0,
});

export const TestContainer = styled(Card)({
  borderRadius: 10,
  width: "70%",
  marginTop: 15,
});

export const TestItem = styled("div")({
  padding: 10,
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#f2f0f2",
});

export const TestButton = styled(Button)({
  width: "fit-content",
  fontSize: 12,
  backgroundColor: "rgba(88, 125, 235, 0.64)",
  cursor: "pointer",
});

export const Progress = styled("div")({
  margin: 5,
  backgroundColor: "#f2f0f2",
});

export const CardHeader = styled(Box)({
  backgroundColor: "rgba(42, 93, 247, 0.75)",
  borderRadius: "10px 10px 0px 0px",
  padding: 5,
});

export const CardHeaderText = styled(Typography)({
  color: "white",
  marginLeft: 20,
  fontSize: 16,
  fontWeight: "bold",
});
